/** The one spring every Spaces motion uses (press, open, close, swipe settle). */
export const SPACE_SPRING = { type: 'spring', stiffness: 500, damping: 38 } as const;

export function countLabel(n: number): string {
  return `${n} ${n === 1 ? 'item' : 'items'}`;
}
